import {
  AllSupplierSettings,
  InputCreateTerritory,
  InputDeleteSupplierImages,
  InputDeleteTerritory,
  InputLinkFranchiseeBranchToTerritory,
  InputUnlinkFranchiseeBranchFromTerritory,
  InputUpdateCoreSupplierSettings,
  InputUpdateTerritories,
  RequestGetTerritorySummary,
  RequestSystemConfiguration,
  ResultCreateTerritory,
  ResultDeleteSupplierImages,
  ResultDeleteTerritory,
  ResultGetCoreSupplierSettings,
  ResultGetTerritorySummary,
  ResultLinkFranchiseeBranchToTerritory,
  ResultSupplierSystemConfiguration,
  ResultUnlinkFranchiseeBranchFromTerritory,
  ResultUpdateCoreSupplierSettings,
  ResultUpdateTerritories
} from './supplier-api-interface-supplier';
import { ApiCommunications, NullPromise } from '../../webmodule-common/interop/webmodule-interop';
import { ResultGetAllUserProfileOfTenant, TenantLoginPublicInfo } from './supplier-api-interface-user';
import { SupplierApi } from './supplier-api';

export class SupplierApiImplementation implements SupplierApi {
  api: ApiCommunications;

  constructor(api: ApiCommunications) {
    this.api = api;
  }
  async getCoreSupplierSettingsEntry(): NullPromise<AllSupplierSettings> {
    const r = await this.api.post<ResultGetCoreSupplierSettings>('api/Settings/GetCoreSupplierSettingsEntry', {});
    if (r === null) {
      return null;
    }
    return r.allSettings ?? null;
  }
  async updateCoreSupplierSettingsEntry(input: InputUpdateCoreSupplierSettings): NullPromise<AllSupplierSettings> {
    const r = await this.api.post<ResultUpdateCoreSupplierSettings>(
      'api/Settings/UpdateCoreSupplierSettingsEntry',
      input
    );
    return r?.settings ?? null;
  }

  async getAllUsers(): NullPromise<TenantLoginPublicInfo[]> {
    const result = await this.api.post<ResultGetAllUserProfileOfTenant>('api/user/GetAllUserProfileOfTenant', {});
    return result?.userProfiles ?? [];
  }

  async getSystemConfiguration(request: RequestSystemConfiguration): NullPromise<ResultSupplierSystemConfiguration> {
    return await this.api.post('api/Settings/GetSystemConfiguration', request);
  }

  async getSupplierTerritories(request: RequestGetTerritorySummary): NullPromise<ResultGetTerritorySummary> {
    return await this.api.post('api/Settings/GetTerritories', request);
  }

  async createSupplierTerritory(input: InputCreateTerritory): NullPromise<ResultCreateTerritory> {
    return await this.api.post('api/Settings/CreateTerritory', input, true);
  }

  async updateSupplierTerritories(input: InputUpdateTerritories): NullPromise<ResultUpdateTerritories> {
    return await this.api.post('api/Settings/UpdateTerritories', input);
  }

  async deleteSupplierTerritory(input: InputDeleteTerritory): NullPromise<ResultDeleteTerritory> {
    return await this.api.post('api/Settings/DeleteTerritory', input);
  }

  async linkFranchiseeBranchToTerritory(
    input: InputLinkFranchiseeBranchToTerritory
  ): NullPromise<ResultLinkFranchiseeBranchToTerritory> {
    return await this.api.post('api/Settings/LinkFranchiseeBranchToTerritory', input);
  }

  async unlinkFranchiseeBranchFromTerritory(
    input: InputUnlinkFranchiseeBranchFromTerritory
  ): NullPromise<ResultUnlinkFranchiseeBranchFromTerritory> {
    return await this.api.post('api/Settings/UnlinkFranchiseeBranchFromTerritory', input);
  }

  async deleteSupplierImages(input: InputDeleteSupplierImages): NullPromise<ResultDeleteSupplierImages> {
    return await this.api.post('api/Settings/DeleteSupplierImages', input);
  }
}
